import React from 'react';
import { Flex, Spacer, Box, Divider } from '@chakra-ui/react';
import Stepper from '@molecules/Stepper';

const DemoStepper = () => {
  return (
    <Box>
      <h2>Steppers</h2>
      <Divider m={2} />
      <Flex align={'center'} gap={2}>
        <p>Sizes</p>
        <Spacer />
        <Stepper size="sm" />
        <Stepper size="md" />
        <Stepper size="lg" />
      </Flex>
    </Box>
  );
};

export default DemoStepper;
